import { Box, Button, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import AddTenderPage from '../../AddTenderPage';
import ManualTenderPage from '../../ManualTenderPage';
import PublicTendersPage from '../../PublicTendersPage';

interface Props {
  onNext: (tenderId?: string) => void;
  onBack: () => void;
  onViewChange?: (view: 'menu' | 'public' | 'manual') => void;
}

export default function Step4NewTender({ onNext, onBack, onViewChange }: Props) {
  const [activeView, setActiveView] = useState<'menu' | 'public' | 'manual'>('menu');

  useEffect(() => {
    if (onViewChange) {
      onViewChange(activeView);
    }
  }, [activeView, onViewChange]);

  if (activeView === 'public') {
    return (
      <Box sx={{ mt: 2 }}>
        <Button onClick={() => setActiveView('menu')} sx={{ mb: 2 }}>
          &larr; Back to Options
        </Button>
        <PublicTendersPage isWizardMode={true} onSuccess={onNext} />
        <Box sx={{ mt: 4, display: 'flex', justifyContent: 'flex-end' }}>
          <Button
            variant="contained"
            size="large"
            sx={{ fontWeight: 'bold', px: 6, py: 1.5, fontSize: '1.1rem' }}
            onClick={() => onNext()}
          >
            I'm done exploring, Continue
          </Button>
        </Box>
      </Box>
    );
  }

  if (activeView === 'manual') {
    return (
      <Box sx={{ mt: 2 }}>
        <Button onClick={() => setActiveView('menu')} sx={{ mb: 2 }}>
          &larr; Back to Options
        </Button>
        <ManualTenderPage isWizardMode={true} onSuccess={onNext} />
      </Box>
    );
  }

  return (
    <Box sx={{ mt: 2 }}>
      <Typography variant="h5" gutterBottom sx={{ fontWeight: 'bold', mb: 2 }}>
        Start a Tender
      </Typography>
      <Typography variant="body1" sx={{ mb: 4, fontSize: '1.2rem' }}>
        You can create a new tender workspace from scratch or browse public tenders to add to your
        dashboard.
      </Typography>

      <Box sx={{ mb: 4 }}>
        <AddTenderPage
          isWizardMode={true}
          onSuccess={onNext}
          onBrowsePublic={() => setActiveView('public')}
          onManualEntry={() => setActiveView('manual')}
        />
      </Box>

      <Box sx={{ mt: 4, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Button onClick={onBack} size="large">
          Back
        </Button>
        <Button
          variant="contained"
          size="large"
          sx={{ fontWeight: 'bold', px: 6, py: 1.5, fontSize: '1.1rem' }}
          onClick={() => onNext()}
        >
          Skip for now (I will do this later)
        </Button>
      </Box>
    </Box>
  );
}
